import { Component, inject, input, model, OnInit } from '@angular/core';
import { IRatingStatsBusinessPartner } from '@pflegix/types';
import { ToastService } from '@pflegix/ui';
import { RatingApi } from '../api';
import { RatingSummaryUIComponent } from './rating-summary-ui.component';

@Component({
  selector: 'pfx-rating-summary',
  imports: [RatingSummaryUIComponent],
  template: `
    <pfx-rating-summary-ui
      [loading]="this.isLoading()"
      [inboundRating]="this.inboundRating"
      [inboundCount]="this.inboundCount"
      [outboundRating]="this.outboundRating"
      [outboundCount]="this.outboundCount"
    >
    </pfx-rating-summary-ui>
  `,
})
export class RatingSummaryComponent implements OnInit {
  public businessPartnerId = input.required<string>();

  private ratingApi = inject(RatingApi);

  private toastService = inject(ToastService);

  public isLoading = model(true);

  protected ratingSummary = model<IRatingStatsBusinessPartner | null>(null);

  public ngOnInit(): void {
    this.getRatingStatisticsForBusinesspartner();
  }

  public get inboundRating(): number {
    return this.ratingSummary()?.author?.summary?.[0]?.averageRating ?? 0;
  }

  public get inboundCount(): number {
    return this.ratingSummary()?.author?.summary?.[0]?.totalCount ?? 0;
  }

  public get outboundRating(): number {
    return this.ratingSummary()?.recipient?.summary?.[0]?.averageRating ?? 0;
  }

  public get outboundCount(): number {
    return this.ratingSummary()?.recipient?.summary?.[0]?.totalCount ?? 0;
  }

  public async getRatingStatisticsForBusinesspartner(): Promise<void> {
    this.isLoading.set(true);
    try {
      this.ratingSummary.set(await this.ratingApi.getRatingStatisticsForBusinesspartner(this.businessPartnerId()));
    } catch {
      this.toastService.addErrorToast('Fehler beim Laden der Bewertungsstatistiken');
    } finally {
      this.isLoading.set(false);
    }
  }
}
